// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"9c7439a3","592":"063f28aa"}[chunkId] + ".chunk.js";
};